// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { OrderLine } from './order-line';
import { OrderLineDetailPart } from './order-line-detail-part';
import { PartAlias } from './part-alias';
import { PartAttachment } from './part-attachment';
import { PartConfiguration } from './part-configuration';
import { PartLink } from './part-link';
import { PartPartServiceChargeLink } from './part-part-service-charge-link';
import { PartPartType } from './part-part-type';
import { PartPurchase } from './part-purchase';
import { PurchaseOrderLine } from './purchase-order-line';
import { QuickBooksAccount } from './quick-books-account';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags
import { Entities } from '../data/entities';
import _ from 'lodash';
import { PurchaseOrder } from './entity-model';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Part extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get serviceCost() {
        const link = _(this.partPartServiceChargeLinks)
            .filter((l) => !l.deleted)
            .orderBy((l) => l.created, 'desc')
            .valueOf()[0];
        if (!link) return null;
        return link.cost;
    }

    get hasServiceCost() {
        return !!this.serviceCost;
    }

    get displayName() {
        if (!!this.partNumber && !!this.description) return `${this.partNumber} - ${this.description}`;
        else return this.partNumber;
    }

    get mfgDisplayName() {
        if (!!this.mfgPartNumber && !!this.mfgDescription) return `${this.mfgPartNumber} - ${this.mfgDescription}`;
        else return this.mfgPartNumber;
    }

    get partTypes() {
        let partTypes = '';
        _(this.partPartTypes)
            .filter((a) => !!a.partType && !a.partType.deleted)
            .sortBy('partType.name')
            .forEach((a) => {
                partTypes = `${partTypes}, ${a.partType?.name}`;
            });
        if (partTypes !== '') partTypes = partTypes.substring(2);
        return partTypes;
    }

    // described as Quantity - Received
    get onOrder() {
        let qty = 0;
        if (!!this.purchaseOrderLines && this.purchaseOrderLines.length > 0) {
            this.purchaseOrderLines.forEach((line) => {
                if (!!line.purchaseOrder && !line.purchaseOrder.deleted && line.purchaseOrder.statusId !== PurchaseOrder.Statuses.Complete)
                    qty += line.quantity - line.quantityReceived;
            });
        }
        return qty;
    }
    get onBackOrder() {
        let qty = 0;
        if (!!this.purchaseOrderLines && this.purchaseOrderLines.length > 0) {
            this.purchaseOrderLines.forEach((line) => {
                if (!!line.purchaseOrder && !line.purchaseOrder.deleted && line.purchaseOrder.statusId !== PurchaseOrder.Statuses.Complete) qty += line.quantityBackOrdered;
            });
        }
        return qty;
    }

    get tier1() {
        return this.getTierPrice(5);
    }
    get tier2() {
        return this.getTierPrice(6);
    }
    get tier3() {
        return this.getTierPrice(7);
    }
    get tier4() {
        return this.getTierPrice(8);
    }
    get tier5() {
        return this.getTierPrice(9);
    }

    get isChild() {
        return !!this.parentPartId;
    }
    get hasChildren() {
        return this.childrenParts.length > 0;
    }
    get hasAliases() {
        return this.partAliases.length > 0;
    }
    get hasAttachments() {
        return this.partAttachments.length > 0;
    }

    getTierPrice(id: number) {
        const tier = _.find(Entities.lookups.pricingTiers, { id: id }) as any;
        if (!!tier && !this.tierPricingOverride) {
            return Math.floor(this.retailPrice * (1 - tier.percentage));
        } else if (!!tier && !!this.tierPricingOverride) {
            return this.retailPrice;
        } else return 0;
    }

    _manualRetailPrice: number;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  assemblyTime!: number;
  axleCount?: number;
  buildTime!: number;
  calculatedCost!: number;
  category?: string;
  changeLog?: string;
  cost!: number;
  created?: Date;
  deleted?: Date;
  description?: string;
  fontColor?: string;
  frameId?: number;
  freightMultiplier?: number;
  inStock?: number;
  isAssembly!: boolean;
  isFreight!: boolean;
  isNonManufactured!: boolean;
  mfgDescription?: string;
  mfgPartNumber?: string;
  note?: string;
  parentPartId?: number;
  partNumber?: string;
  prePaymentDiscountOverride!: boolean;
  preferredVendor?: string;
  price!: number;
  processing?: number;
  quickBooksAccountId?: number;
  reOrderMinimum!: number;
  reOrderQuantity!: number;
  reportGuid?: string;
  retailPrice!: number;
  revision?: string;
  tierPricingOverride!: boolean;
  trackInventory!: boolean;
  unitOfMeasure?: string;
  vINPrefix?: string;
  vendorId?: number;
  childrenParts!: Part[];
  frame!: Part;
  frameParts!: Part[];
  orderLineDetailParts!: OrderLineDetailPart[];
  orderLines!: OrderLine[];
  parentPart!: Part;
  partAliases!: PartAlias[];
  partAttachments!: PartAttachment[];
  partConfigurations!: PartConfiguration[];
  partLinks!: PartLink[];
  partPartServiceChargeLinks!: PartPartServiceChargeLink[];
  partPartTypes!: PartPartType[];
  partPurchases!: PartPurchase[];
  purchaseOrderLines!: PurchaseOrderLine[];
  quickBooksAccount!: QuickBooksAccount;
  subPartLinks!: PartLink[];
  vendor!: Vendor;
}

